/**
 * 变体 H — 叶子对比勾选
 *
 * The leaf tick on each product card is a plain <input type="checkbox"> styled
 * with a leaf. This file only keeps the picks in sync across the three separate
 * product sections (and across a reload) and maintains a small floating bar.
 *
 * Kept deliberately small: there is no compare page yet, so the bar shows what
 * is selected and offers Clear rather than linking somewhere that does not exist.
 */
(() => {
  const KEY = 'limeh:compare';
  const MAX = 4;

  const read = () => {
    try {
      const raw = JSON.parse(sessionStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  };

  const write = (list) => {
    try { sessionStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  };

  const picks = () => Array.from(document.querySelectorAll('[data-lh-pick]'));

  let bar = null;

  const buildBar = () => {
    bar = document.createElement('div');
    bar.className = 'lh-compare';
    bar.setAttribute('role', 'status');
    bar.hidden = true;
    bar.innerHTML =
      '<div class="lh-compare__inner">' +
        '<span class="lh-compare__leaf" aria-hidden="true">' +
          '<svg viewBox="0 0 64 120" fill="none" focusable="false">' +
            '<path d="M32,4 C58,30 58,74 32,116 C6,74 6,30 32,4 Z" stroke="currentColor" stroke-width="3.4" stroke-linejoin="round"/>' +
            '<path d="M32,10 L32,112" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" opacity=".7"/>' +
          '</svg>' +
        '</span>' +
        '<span class="lh-compare__count"></span>' +
        '<span class="lh-compare__names"></span>' +
        '<button type="button" class="lh-compare__clear">Clear</button>' +
      '</div>';
    document.body.appendChild(bar);
    bar.querySelector('.lh-compare__clear').addEventListener('click', () => {
      write([]);
      sync();
    });
  };

  const sync = () => {
    const stored = read();

    // reflect stored state onto every checkbox on the page
    picks().forEach((input) => {
      const on = stored.indexOf(input.value) !== -1;
      if (input.checked !== on) input.checked = on;
      input.closest('.lh-pick').classList.toggle('is-picked', on);
    });

    if (!bar) buildBar();

    if (!stored.length) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    bar.querySelector('.lh-compare__count').textContent =
      stored.length + (stored.length === 1 ? ' item selected' : ' items selected');
    bar.querySelector('.lh-compare__names').textContent = stored.join(' · ');
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-lh-pick]');
    if (!input) return;

    let list = read();
    const at = list.indexOf(input.value);

    if (input.checked) {
      if (at === -1) list.push(input.value);
      if (list.length > MAX) {
        // refuse rather than silently dropping someone's earlier pick
        input.checked = false;
        list = list.slice(0, MAX);
      }
    } else if (at !== -1) {
      list.splice(at, 1);
    }

    write(list);
    sync();
  });

  // section rendering in the theme editor swaps cards in and out
  document.addEventListener('shopify:section:load', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
